import { globalAxios, coreInstance2, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    provinceData: [],
    province_list: [],
    district_list: [],
    sub_district_list: [],
    zip_code_list: [],
    provinceServiceData: [],
    serviceDetail: {}
  },
  mutations: {
    getData(state, data) {
      state.provinceData = data;
    },
    getProvinceList(state, data) {
      state.province_list = data;
    },
    getDistrictList(state, data) {
      state.district_list = data;
    },
    getSubDistrictList(state, data) {
      state.sub_district_list = data;
    },
    getZipCodeList(state, data) {
      state.zip_code_list = data;
    },
    resetLocateList(state) {
      (state.district_list = []),
        (state.sub_district_list = []),
        (state.zip_code_list = []);
    },
    setProvinceServinceData(state, data) {
      for (let val of data) {
        for (let service of val.province_service_list) {
          service.service_status = false
          if (!service.service_inactive_detail || Object.keys(service.service_inactive_detail).length == 0) {
            service.service_inactive_detail = {
              "service_inactive_type": 0,
              "service_inactive_image": "https://storage.googleapis.com/internal-weserve/img/none/no_img.png",
              "service_inactive_icon": "https://storage.googleapis.com/internal-weserve/img/none/no_img.png",
              "service_inactive_title_th": null,
              "service_inactive_title_en": null,
              "service_inactive_description_th": null,
              "service_inactive_description_en": null
            }
          }
        }
      }
      state.provinceServiceData = data
    },
    setServinceDetail(state, data) {
      state.serviceDetail = data
    }
  },
  actions: {
    async openCloseService({ dispatch }, configPath) {
      let url = backendVersion.version + '/service/app/addService/' + configPath.province_id + '/' + configPath.service_id
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: {} },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false
      } else {
        if (res.msg == true) {

          return true
        } else {
          return false
        }
      }
    },
    async toggleShowHideService({ dispatch }, configPath) {
      let url = backendVersion.version + '/service/app/showService/' + configPath.province_id + '/' + configPath.service_id
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: {} },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false
      } else {
        if (res.msg == true) {

          return true
        } else {
          return false
        }
      }
    },
    async editServiceDetail({ dispatch }, { configPath, form }) {
      let url = backendVersion.version + '/service/app/editService/' + configPath.province_id + '/' + configPath.service_id
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false
      } else {
        if (res.msg == true) {

          return true
        } else {
          return false
        }

      }
    },
    async getServiceDetail({ commit, dispatch }, configPath) {
      let url = backendVersion.version + '/service/app/getService/' + configPath.province_id + '/' + configPath.service_id
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (res.msg == true) {
          return res.data;
        } else {
          return false
        }
      }
    },
    async getProvinceServiceList({ commit, dispatch }) {
      let url = backendVersion.version + '/service/app/list'
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (res.msg == true) {
          commit('setProvinceServinceData', res.data)
          return res;
        } else {
          return false
        }
      }
    },
    async getData({ commit, dispatch }) {
      let url = backendVersion.version + "/province/onuse";
      return coreInstance2
        .get(url)
        .then((data) => {
          commit("setDisconnect", false, { root: true });
          commit("getData", data);
          return data;
        })
        .catch((err) => {
          return [];
        });
      // let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
      //   root: true
      // });
      // if (typeof res == "boolean" && res == false) {
      //   return false;
      // } else {
      //   commit("setDisconnect", false, { root: true });
      //   commit("getData", res);
      //   return res;
      // }
    },
    async getProvinceList({ commit, rootState, dispatch }) {
      commit("resetLocateList");
      let url = rootState.api_urls.fetchProvinceBack_getProvinceList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return {};
      } else {
        commit("getProvinceList", res);
        return res;
      }
    },
    async getDistrictList({ commit, rootState, dispatch }, province_id) {
      commit("resetLocateList");
      let url =
        rootState.api_urls.fetchProvinceBack_getDistrictList + province_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return;
      } else {
        commit("getDistrictList", res);
        return;
      }
    },
    async getSubDistrictList({ commit, rootState, dispatch }, district_id) {
      let url =
        rootState.api_urls.fetchProvinceBack_getSubDistrictList + district_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return;
      } else {
        commit("getSubDistrictList", res);
        return;
      }
    },
    async getZipCodeList({ commit, rootState, dispatch }, district_id) {
      let url =
        rootState.api_urls.fetchProvinceBack_getZipCodeList + district_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return;
      } else {
        commit("getZipCodeList", res);
        return;
      }
    },
    async getDistrictCore({ state, commit, dispatch }, province_id) {
      let url = backendVersion.version + "/select/district/" + province_id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {

        return res;
      }
    },
    async getSubDistrictCore({ state, commit, dispatch }, id) {
      let url = backendVersion.version + "/select/sub_district/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {

        return res;
      }
    },
    async getZipCodeCore({ commit, dispatch }, id) {
      let url = backendVersion.version + "/select/zipcode/" + id;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {

        return res;
      }
    },
    async updateServiceBanner({ dispatch }, { form, config }) {
      let url = `${backendVersion.version}/service/app/UpdateServiceImage/${config.province_id}/${config.service_type}`
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res === false) {
        return false
      } else {
        if (res.msg == true) {
          return res.data
        } else {
          if ('data' in res) {
            alert(res.data)
          }
          return false
        }
      }
    },
    async fetchDistrictListByMultipleProvinceID({ commit }, provinceIdList) {
      let url = `/api/v1/district_list_by_province`;
      return globalAxios
        .get(url, { params: { province_id: JSON.stringify(provinceIdList) } })
        .then((res) => {
          console.log(res);
          if (res.msg === false) return false;
          return res.data;
        })
        .catch((error) => false);
    },
    async getProvinceCore({ state, commit, dispatch }, id) {
      let url = backendVersion.version + "/select/province";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {

        return res;
      }
    },
  },
  getters: {
    provinceSplited(state) {
      let province_list = [];
      for (let val of state.provinceData) {
        let province = JSON.parse(JSON.stringify(val));
        province.province_name_en = province.province_name_en.toLowerCase();
        let province_split = province.province_name_en.split(" ");
        province.province_name_en = "";
        for (let val of province_split) {
          province.province_name_en += val;
        }
        province_list.push(province);
      }
      return province_list;
    }
  }
};
